var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('video',{ref:"videoVodTengface",attrs:{"height":"100%","width":"100%","preload":"","loop":"","x5-video-player-fullscreen":"true","x5-playsinline":"","playsinline":"","webkit-playsinline":"","controls":_vm.controls},domProps:{"muted":_vm.isMuted},on:{"play":_vm.handlePlay,"pause":_vm.handlePause,"timeupdate":_vm.timeupdate}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c87fc9e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/hlsvideo.vue
// module id = null
// module chunks = 